'use client';

import { ApolloProvider } from '@apollo/client';
import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import { apolloClientCsr } from '~/clients/apollo-client-csr';

interface ApolloClientProviderProps {
  children?: ReactNode;
}

export const ApolloClientProvider = dynamic(
  () =>
    Promise.resolve(({ children }: ApolloClientProviderProps) => (
      <ApolloProvider client={apolloClientCsr}>{children}</ApolloProvider>
    )),
  { ssr: false },
);
